<template>
  <validation-provider
    v-slot="{ errors }"
    :name="$attrs.label"
    :rules="rules"
  >
    <v-select
      v-model="innerValue"
      :error-messages="errors"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </validation-provider>
</template>

<script>
  import { ValidationProvider } from 'vee-validate'

  export default {
    components: {
      ValidationProvider,
    },
    props: {
      rules: {
        type: [Object, String],
        default: '',
      },
      value: {
        type: null,
        default: 0,
      },
    },
    data: () => ({
      innerValue: '',
    }),
    watch: {
      // Handles internal model changes.
      innerValue (newVal) {
        this.$emit('input', newVal)
      },
      // Handles external model changes.
      value (newVal) {
        this.innerValue = newVal
      },
    },
    created () {
      if (this.value) {
        this.innerValue = this.value
      }
    },
  }
</script>
